import React from "react";
import styled from "styled-components";

const IconContainer = styled.div`
  color: ${(props) => props.color ? props.color : '#ffff'};
`;

export default function ButtonIconContainer(props) {
  return <IconContainer color={props.color}>{props.children}</IconContainer>;
}
